 import moment from "moment/moment"

  export const balanceTypes =[
    {id:0, name:'Stocks', label:'all', code:0,},
    {id:1, name:'Customers', label:'customers', code:123},
    {id:2, name:'Customers', label:'suppliers', code:261},
  ]
  export const deptTypes =[
    {id:1, name:'Customers', label:'customers', code:123},
    {id:2, name:'Customers', label:'suppliers', code:261},
  ]
  export const payTypes =[
    {id:0, label:'all'},
    {id:1, label:'paid-done'},
    {id:2, label:'not-paid'},
  ]

   export const getSAdefaultValues = (t) => ({
        firstTime: true,
        type: balanceTypes[0],
        dateFrom: moment(new Date()).format('YYYY-MM-DD'),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        payType: payTypes[0],
        branch:{id:-1, name:t('all')},
        center:{id:-1, name:t('all')},
        account: {id: '0', name:''},
        omla:{id:-1, name:t('all')},
        user:{id:-1, name:t('all')},
        salesmen:{id:-1, name:t('all')},
        act:{id:-1, name:t('all')},
        openBalance:true,
        oldBalance: true,
      
    });